<template>
  <div>
    <Header />
    <Details />
    <Footer />
    <SocialLinks />
  </div>
</template>

<script>
  import Header from '../components/common/Header'
  import Details from '../components/Blog/Details'
  import Footer from '../components/common/Footer'
  import SocialLinks from '../components/common/SocialLinks'

  export default {
    name: 'Blog',
    metaInfo: {
      title: 'Blog',
    },
    components: {
      Header,
      Details,
      Footer,
      SocialLinks
    },
  }
</script>

<style>
.content {
  text-align: left;
  margin-top: 50px;
  margin-bottom: 50px;
}
.text-heading {
  font-weight: 600;
}
.blog-content .post-content-container {
  border-bottom: 1px solid #aeaeae;
  margin-bottom: 20px;
  padding-bottom: 20px;
  padding-top: 20px
}
.blog-content .post-content-container:last-child {
  border-bottom: none;
}
.blog-content .icon-image {
  position: relative;
  bottom: 5px;
  left: 10px;
}
.blog-content a {
  text-decoration: none;
  color: #6E2169;
}
</style>